const areaKeysDe = {
  tenant: 'Mandant und Firma',
  numberRanges: 'Nummernkreise (ohne Zählerstände)',
  customFields: 'Zusatzfelder und Kategorien',
  translations: 'Übersetzungen und Glossare',
  documentTemplates: 'Beleg- und PDF-Vorlagen',
  emailTemplates: 'E-Mail-Vorlagen',
  paymentTerms: 'Zahlungsbedingungen',
  deliveryTerms: 'Lieferbedingungen',
  taxConfiguration: 'Steuerkonfiguration',
  features: 'Funktionen und Module',
  rolesAndPermissions: 'Rollen und Berechtigungen',
  teams: 'Teams und Zuordnungen',
  users: 'Benutzergrunddaten',
  dashboard: 'Dashboard-Konfiguration',
  notifications: 'Benachrichtigungseinstellungen',
  importProfiles: 'Importprofile',
  warehouses: 'Lager und Standorte',
  otherSettings: 'Weitere Mandanteneinstellungen',
  products: 'Artikel',
  productImages: 'Artikelbilder',
  customers: 'Kunden',
  leads: 'Interessenten',
  suppliers: 'Lieferanten',
  contacts: 'Ansprechpartner',
  addresses: 'Adressen',
  priceLists: 'Preislisten',
  productGroups: 'Warengruppen und Produktgruppen',
  recipes: 'Stücklisten und Rezepturen',
  specifications: 'Spezifikationen',
} as const;

const statusKeysDe = {
  QUEUED: 'Wartet',
  RUNNING: 'Läuft',
  COMPLETED: 'Abgeschlossen',
  FAILED: 'Fehlgeschlagen',
  CANCEL_REQUESTED: 'Abbruch angefordert',
  CANCELLED: 'Abgebrochen',
  EXPIRED: 'Abgelaufen',
} as const;
const stepKeysDe = {
  prepare: 'Vorbereitung',
  database: 'Datenbank',
  files: 'Dateien',
  manifest: 'Manifest',
  encrypt: 'Verschlüsselung',
  completed: 'Fertig',
  cancelled: 'Abgebrochen',
  failed: 'Fehlgeschlagen',
  expired: 'Abgelaufen',
  ...areaKeysDe,
} as const;

export const backupCenterDe = {
  title: 'Backup-Center',
  description: 'Portable Exporte und vollständige Notfallsicherungen mandantengetrennt erstellen.',
  systemStatus: {
    title: 'Serverweite Backup-Absicherung',
    unavailable: 'Der serverweite Backup-Status ist derzeit nicht verfügbar.',
    mode: 'Backup-Modus',
    modes: { local: 'Lokal', 'local+offsite': 'Lokal + Offsite' },
    restic: 'Restic',
    enabled: 'Aktiviert',
    disabled: 'Deaktiviert',
    lastLocalBackup: 'Letztes lokales Backup',
    localIntegrity: 'Lokale Integritätsprüfung',
    verified: 'Verifiziert',
    notVerified: 'Nicht verifiziert',
    lastRestoreTest: 'Letzter Restore-Test',
    offsiteStatus: 'Offsite-Status',
    localOnlyTitle: 'Lokales Backup aktiv / Offsite deaktiviert',
    localOnlyWarning:
      'Ein vollständiger Ausfall oder Verlust dieses Servers kann auch alle lokalen Backups zerstören.',
    operatorHint:
      'Ein externer Backup-Speicher kann später durch den Serverbetreiber eingerichtet werden. Zugangsdaten und RESTIC_ENABLED werden ausschließlich außerhalb des Backup-Centers verwaltet.',
  },
  typeLabel: 'Backup-Typ',
  types: {
    SETTINGS: {
      title: 'Einstellungen',
      description:
        'Portable Konfiguration ohne Passwörter, Tokens, Sitzungen oder Geschäftsvorfälle.',
    },
    MASTER_DATA: {
      title: 'Stammdaten',
      description: 'Ausgewählte Kunden-, Lieferanten-, Artikel- und Produktentwicklungsdaten.',
    },
    FULL: {
      title: 'Disaster Recovery',
      description: 'Konsistenter PostgreSQL-Dump und private DMS-Dateien für den Notfall.',
    },
  },
  typeNames: {
    SETTINGS: 'Einstellungsbackup',
    MASTER_DATA: 'Stammdatenbackup',
    FULL: 'Disaster-Recovery-Backup',
  },
  fullWarningTitle: 'Enthält den vollständigen Systemzustand',
  fullWarning:
    'Diese Sicherung enthält Bewegungsdaten und kann sensible Inhalte enthalten. Sie wird vor der Ablage mit AES-256-GCM verschlüsselt.',
  areaLegend: 'Enthaltene Bereiche',
  settingsHint:
    'Benutzer sind optional und werden nur mit Grunddaten exportiert. Nach einem Restore ist eine neue Einladung erforderlich.',
  masterHint: 'Benötigte Artikel- oder Partnerbezüge werden automatisch ergänzt.',
  reinvite: 'Neue Einladung',
  create: 'Sicherung erstellen',
  queued: 'Sicherung wurde in die Warteschlange gestellt.',
  encryptionNotice: 'Archive werden privat gespeichert und immer authentifiziert verschlüsselt.',
  encryptionRequired: 'AES-256-GCM ist aus Sicherheitsgründen verpflichtend.',
  history: 'Sicherungsverlauf',
  processing: 'Verarbeitung aktiv',
  empty: 'Noch keine Sicherungsaufträge.',
  backup: 'Sicherung',
  status: 'Status',
  scope: 'Umfang und Größe',
  createdAt: 'Erstellt',
  progress: '{{value}} Prozent abgeschlossen',
  expires: 'Download bis {{timestamp}}',
  schedule: 'Zeitplan und Aufbewahrung',
  cancel: 'Sicherung abbrechen',
  download: 'Sicherung herunterladen',
  delete: 'Sicherung löschen',
  deleteTitle: 'Sicherung endgültig löschen?',
  deleteDescription: 'Das verschlüsselte Archiv und sein Auftrag werden dauerhaft entfernt.',
  deleted: 'Sicherung gelöscht.',
  areas: areaKeysDe,
  statuses: statusKeysDe,
  steps: stepKeysDe,
} as const;

const areaKeysEn = {
  tenant: 'Tenant and company',
  numberRanges: 'Number ranges (without counters)',
  customFields: 'Custom fields and categories',
  translations: 'Translations and glossaries',
  documentTemplates: 'Document and PDF templates',
  emailTemplates: 'Email templates',
  paymentTerms: 'Payment terms',
  deliveryTerms: 'Delivery terms',
  taxConfiguration: 'Tax configuration',
  features: 'Features and modules',
  rolesAndPermissions: 'Roles and permissions',
  teams: 'Teams and assignments',
  users: 'Basic user data',
  dashboard: 'Dashboard configuration',
  notifications: 'Notification settings',
  importProfiles: 'Import profiles',
  warehouses: 'Warehouses and locations',
  otherSettings: 'Other tenant settings',
  products: 'Products',
  productImages: 'Product images',
  customers: 'Customers',
  leads: 'Prospects',
  suppliers: 'Suppliers',
  contacts: 'Contacts',
  addresses: 'Addresses',
  priceLists: 'Price lists',
  productGroups: 'Product categories and groups',
  recipes: 'Bills of materials and recipes',
  specifications: 'Specifications',
} as const;
const statusKeysEn = {
  QUEUED: 'Queued',
  RUNNING: 'Running',
  COMPLETED: 'Completed',
  FAILED: 'Failed',
  CANCEL_REQUESTED: 'Cancellation requested',
  CANCELLED: 'Cancelled',
  EXPIRED: 'Expired',
} as const;
const stepKeysEn = {
  prepare: 'Preparing',
  database: 'Database',
  files: 'Files',
  manifest: 'Manifest',
  encrypt: 'Encryption',
  completed: 'Completed',
  cancelled: 'Cancelled',
  failed: 'Failed',
  expired: 'Expired',
  ...areaKeysEn,
} as const;

export const backupCenterEn = {
  title: 'Backup center',
  description: 'Create tenant-isolated portable exports and complete disaster-recovery backups.',
  systemStatus: {
    title: 'Server-wide backup protection',
    unavailable: 'The server-wide backup status is currently unavailable.',
    mode: 'Backup mode',
    modes: { local: 'Local', 'local+offsite': 'Local + offsite' },
    restic: 'Restic',
    enabled: 'Enabled',
    disabled: 'Disabled',
    lastLocalBackup: 'Last local backup',
    localIntegrity: 'Local integrity check',
    verified: 'Verified',
    notVerified: 'Not verified',
    lastRestoreTest: 'Last restore test',
    offsiteStatus: 'Offsite status',
    localOnlyTitle: 'Local backup active / offsite disabled',
    localOnlyWarning:
      'A complete failure or loss of this server can also destroy every local backup.',
    operatorHint:
      'The server operator can add external backup storage later. Credentials and RESTIC_ENABLED are managed only outside the backup center.',
  },
  typeLabel: 'Backup type',
  types: {
    SETTINGS: {
      title: 'Settings',
      description: 'Portable configuration without passwords, tokens, sessions or transactions.',
    },
    MASTER_DATA: {
      title: 'Master data',
      description: 'Selected customer, supplier, product and product-development data.',
    },
    FULL: {
      title: 'Disaster recovery',
      description: 'Consistent PostgreSQL dump and private DMS files for emergencies.',
    },
  },
  typeNames: {
    SETTINGS: 'Settings backup',
    MASTER_DATA: 'Master-data backup',
    FULL: 'Disaster-recovery backup',
  },
  fullWarningTitle: 'Contains the complete system state',
  fullWarning:
    'This backup includes transactions and may contain sensitive content. It is encrypted with AES-256-GCM before storage.',
  areaLegend: 'Included areas',
  settingsHint:
    'Users are optional and exported with basic data only. A new invitation is required after restore.',
  masterHint: 'Required product or partner references are added automatically.',
  reinvite: 'New invitation',
  create: 'Create backup',
  queued: 'The backup was queued.',
  encryptionNotice: 'Archives are stored privately and always use authenticated encryption.',
  encryptionRequired: 'AES-256-GCM is mandatory for security.',
  history: 'Backup history',
  processing: 'Processing active',
  empty: 'No backup jobs yet.',
  backup: 'Backup',
  status: 'Status',
  scope: 'Scope and size',
  createdAt: 'Created',
  progress: '{{value}} percent complete',
  expires: 'Download until {{timestamp}}',
  schedule: 'Schedule and retention',
  cancel: 'Cancel backup',
  download: 'Download backup',
  delete: 'Delete backup',
  deleteTitle: 'Permanently delete backup?',
  deleteDescription: 'The encrypted archive and its job will be permanently removed.',
  deleted: 'Backup deleted.',
  areas: areaKeysEn,
  statuses: statusKeysEn,
  steps: stepKeysEn,
} as const;

export const backupCenterFr = {
  ...backupCenterEn,
  title: 'Centre de sauvegarde',
  description:
    'Créez des exports portables isolés par client et des sauvegardes complètes de reprise.',
  systemStatus: {
    title: 'Protection des sauvegardes à l’échelle du serveur',
    unavailable: 'L’état des sauvegardes du serveur est actuellement indisponible.',
    mode: 'Mode de sauvegarde',
    modes: { local: 'Local', 'local+offsite': 'Local + externe' },
    restic: 'Restic',
    enabled: 'Activé',
    disabled: 'Désactivé',
    lastLocalBackup: 'Dernière sauvegarde locale',
    localIntegrity: 'Contrôle d’intégrité local',
    verified: 'Vérifié',
    notVerified: 'Non vérifié',
    lastRestoreTest: 'Dernier test de restauration',
    offsiteStatus: 'État externe',
    localOnlyTitle: 'Sauvegarde locale active / externe désactivée',
    localOnlyWarning:
      'Une panne totale ou la perte de ce serveur peut également détruire toutes les sauvegardes locales.',
    operatorHint:
      'L’exploitant du serveur peut ajouter ultérieurement un stockage externe. Les identifiants et RESTIC_ENABLED sont gérés uniquement hors du centre de sauvegarde.',
  },
  typeLabel: 'Type de sauvegarde',
  types: {
    SETTINGS: {
      title: 'Paramètres',
      description: 'Configuration portable sans mots de passe, jetons, sessions ni transactions.',
    },
    MASTER_DATA: {
      title: 'Données de base',
      description:
        'Données clients, fournisseurs, articles et développement produit sélectionnées.',
    },
    FULL: {
      title: 'Reprise après sinistre',
      description: 'Dump PostgreSQL cohérent et fichiers DMS privés pour les urgences.',
    },
  },
  typeNames: {
    SETTINGS: 'Sauvegarde des paramètres',
    MASTER_DATA: 'Sauvegarde des données de base',
    FULL: 'Sauvegarde de reprise',
  },
  create: 'Créer la sauvegarde',
  queued: 'La sauvegarde a été mise en file.',
  history: 'Historique des sauvegardes',
  processing: 'Traitement en cours',
  empty: 'Aucune sauvegarde.',
  backup: 'Sauvegarde',
  status: 'État',
  scope: 'Contenu et taille',
  createdAt: 'Créée',
  cancel: 'Annuler la sauvegarde',
  download: 'Télécharger la sauvegarde',
  delete: 'Supprimer la sauvegarde',
  schedule: 'Planification et conservation',
  areas: areaKeysEn,
} as const;

export const backupCenterEs = {
  ...backupCenterEn,
  title: 'Centro de copias de seguridad',
  description:
    'Crea exportaciones portátiles aisladas por tenant y copias completas de recuperación.',
  systemStatus: {
    title: 'Protección de copias en todo el servidor',
    unavailable: 'El estado de las copias del servidor no está disponible en este momento.',
    mode: 'Modo de copia',
    modes: { local: 'Local', 'local+offsite': 'Local + externa' },
    restic: 'Restic',
    enabled: 'Activado',
    disabled: 'Desactivado',
    lastLocalBackup: 'Última copia local',
    localIntegrity: 'Comprobación de integridad local',
    verified: 'Verificada',
    notVerified: 'No verificada',
    lastRestoreTest: 'Última prueba de restauración',
    offsiteStatus: 'Estado externo',
    localOnlyTitle: 'Copia local activa / externa desactivada',
    localOnlyWarning:
      'Un fallo total o la pérdida de este servidor también puede destruir todas las copias locales.',
    operatorHint:
      'El operador del servidor puede añadir después un almacenamiento externo. Las credenciales y RESTIC_ENABLED solo se gestionan fuera del centro de copias.',
  },
  typeLabel: 'Tipo de copia',
  types: {
    SETTINGS: {
      title: 'Configuración',
      description: 'Configuración portátil sin contraseñas, tokens, sesiones ni transacciones.',
    },
    MASTER_DATA: {
      title: 'Datos maestros',
      description:
        'Datos seleccionados de clientes, proveedores, artículos y desarrollo de producto.',
    },
    FULL: {
      title: 'Recuperación ante desastres',
      description: 'Volcado PostgreSQL coherente y archivos DMS privados para emergencias.',
    },
  },
  typeNames: {
    SETTINGS: 'Copia de configuración',
    MASTER_DATA: 'Copia de datos maestros',
    FULL: 'Copia de recuperación',
  },
  create: 'Crear copia',
  queued: 'La copia se añadió a la cola.',
  history: 'Historial de copias',
  processing: 'Procesamiento activo',
  empty: 'Todavía no hay copias.',
  backup: 'Copia',
  status: 'Estado',
  scope: 'Contenido y tamaño',
  createdAt: 'Creada',
  cancel: 'Cancelar copia',
  download: 'Descargar copia',
  delete: 'Eliminar copia',
  schedule: 'Planificación y retención',
  areas: areaKeysEn,
} as const;

export const backupCenterTr = {
  ...backupCenterEn,
  title: 'Yedekleme merkezi',
  description:
    'Kiracıya özel taşınabilir dışa aktarımlar ve tam felaket kurtarma yedekleri oluşturun.',
  systemStatus: {
    title: 'Sunucu genelinde yedekleme koruması',
    unavailable: 'Sunucu yedekleme durumu şu anda kullanılamıyor.',
    mode: 'Yedekleme modu',
    modes: { local: 'Yerel', 'local+offsite': 'Yerel + harici' },
    restic: 'Restic',
    enabled: 'Etkin',
    disabled: 'Devre dışı',
    lastLocalBackup: 'Son yerel yedek',
    localIntegrity: 'Yerel bütünlük kontrolü',
    verified: 'Doğrulandı',
    notVerified: 'Doğrulanmadı',
    lastRestoreTest: 'Son geri yükleme testi',
    offsiteStatus: 'Harici durum',
    localOnlyTitle: 'Yerel yedek etkin / harici yedek devre dışı',
    localOnlyWarning:
      'Bu sunucunun tamamen arızalanması veya kaybolması tüm yerel yedekleri de yok edebilir.',
    operatorHint:
      'Sunucu işletmecisi harici yedekleme alanını daha sonra ekleyebilir. Kimlik bilgileri ve RESTIC_ENABLED yalnızca yedekleme merkezi dışında yönetilir.',
  },
  typeLabel: 'Yedek türü',
  types: {
    SETTINGS: {
      title: 'Ayarlar',
      description: 'Parola, belirteç, oturum veya işlem içermeyen taşınabilir yapılandırma.',
    },
    MASTER_DATA: {
      title: 'Ana veriler',
      description: 'Seçilen müşteri, tedarikçi, ürün ve ürün geliştirme verileri.',
    },
    FULL: {
      title: 'Felaket kurtarma',
      description: 'Acil durumlar için tutarlı PostgreSQL dökümü ve özel DMS dosyaları.',
    },
  },
  typeNames: {
    SETTINGS: 'Ayar yedeği',
    MASTER_DATA: 'Ana veri yedeği',
    FULL: 'Felaket kurtarma yedeği',
  },
  create: 'Yedek oluştur',
  queued: 'Yedek kuyruğa alındı.',
  history: 'Yedek geçmişi',
  processing: 'İşlem sürüyor',
  empty: 'Henüz yedek işi yok.',
  backup: 'Yedek',
  status: 'Durum',
  scope: 'Kapsam ve boyut',
  createdAt: 'Oluşturuldu',
  cancel: 'Yedeği iptal et',
  download: 'Yedeği indir',
  delete: 'Yedeği sil',
  schedule: 'Zamanlama ve saklama',
  areas: areaKeysEn,
} as const;

export const backupRestoreDe = {
  title: 'Wiederherstellung',
  description:
    'Archive zuerst vollständig prüfen, Konflikte entscheiden und erst danach wiederherstellen.',
  fromExisting: 'Vorhandene Sicherung prüfen',
  noSource: 'Keine fertige Sicherung verfügbar.',
  or: 'oder',
  upload: 'Verschlüsseltes Archiv hochladen',
  validating: 'Archiv wird geprüft',
  selectHint:
    'Wählen Sie eine Sicherung oder laden Sie ein Archiv hoch. Die Trockenlaufprüfung verändert keine Daten.',
  preview: 'Validierte Restore-Vorschau',
  noPreview: 'Für diesen Restore ist keine gültige Vorschau verfügbar.',
  type: 'Typ',
  records: 'Datensätze',
  files: 'Geprüfte Dateien',
  source: 'Quelle',
  missingDependencies: 'Fehlende Abhängigkeiten',
  featureIssues: 'Prüfung der Funktionskonfiguration',
  featureIssueCodes: {
    UNKNOWN_KEY: 'Unbekannter Schlüssel wird übersprungen',
    INVALID_SETTING: 'Ungültiger Status wird übersprungen',
    SYSTEM_CORE_FORCED_ACTIVE: 'Systemkern bleibt aktiv',
    DEPENDENCY_BLOCKED: 'Abhängigkeit wäre nicht verfügbar',
    CONFIGURATION_MISSING: 'Konfiguration fehlt in der Zielumgebung',
  },
  offlineTitle: 'Offline-Wiederherstellung erforderlich',
  offlineHint:
    'Ein vollständiger Datenbank-Restore wird nach Bestätigung mit dem Serverwerkzeug im Wartungsfenster ausgeführt. Die Webanwendung überschreibt ihre laufende Datenbank nicht selbst.',
  confirmation: 'Zusätzliche Disaster-Recovery-Bestätigung',
  strategy: 'Konfliktstrategie',
  strategies: {
    CREATE_ONLY: 'Nur neue Daten anlegen',
    UPDATE_EXISTING: 'Vorhandene Daten aktualisieren',
    MANUAL: 'Jeden Konflikt entscheiden',
  },
  skipAreas: 'Bereiche überspringen',
  conflicts: '{{count}} Konflikte',
  conflictDecision: 'Entscheidung für Konflikt',
  decide: 'Entscheiden',
  update: 'Aktualisieren',
  skip: 'Überspringen',
  create: 'Neu anlegen',
  execute: 'Sicherheitsbackup erstellen und wiederherstellen',
  queued: 'Restore wurde nach gültiger Vorschau eingeplant.',
  history: 'Restore-Verlauf',
  report: 'Ergebnisbericht herunterladen',
  statuses: {
    VALIDATING: 'Wird geprüft',
    READY: 'Bereit',
    QUEUED: 'Wartet',
    RUNNING: 'Wird wiederhergestellt',
    COMPLETED: 'Abgeschlossen',
    FAILED: 'Fehlgeschlagen',
  },
} as const;

export const backupRestoreEn = {
  title: 'Restore',
  description: 'Validate every archive, resolve conflicts and only then restore data.',
  fromExisting: 'Validate an existing backup',
  noSource: 'No completed backup is available.',
  or: 'or',
  upload: 'Upload encrypted archive',
  validating: 'Validating archive',
  selectHint: 'Select a backup or upload an archive. The dry run does not modify data.',
  preview: 'Validated restore preview',
  noPreview: 'No valid preview is available for this restore.',
  type: 'Type',
  records: 'Records',
  files: 'Verified files',
  source: 'Source',
  missingDependencies: 'Missing dependencies',
  featureIssues: 'Feature configuration check',
  featureIssueCodes: {
    UNKNOWN_KEY: 'Unknown key will be skipped',
    INVALID_SETTING: 'Invalid state will be skipped',
    SYSTEM_CORE_FORCED_ACTIVE: 'System core remains active',
    DEPENDENCY_BLOCKED: 'A dependency would be unavailable',
    CONFIGURATION_MISSING: 'Configuration is missing in the target environment',
  },
  offlineTitle: 'Offline restore required',
  offlineHint:
    'After explicit confirmation, a full database restore is performed with the server tool during a maintenance window. The web app never overwrites its live database itself.',
  confirmation: 'Additional disaster-recovery confirmation',
  strategy: 'Conflict strategy',
  strategies: {
    CREATE_ONLY: 'Create new data only',
    UPDATE_EXISTING: 'Update existing data',
    MANUAL: 'Resolve every conflict',
  },
  skipAreas: 'Skip areas',
  conflicts: '{{count}} conflicts',
  conflictDecision: 'Conflict decision',
  decide: 'Decide',
  update: 'Update',
  skip: 'Skip',
  create: 'Create',
  execute: 'Create safety backup and restore',
  queued: 'Restore was queued after a valid preview.',
  history: 'Restore history',
  report: 'Download result report',
  statuses: {
    VALIDATING: 'Validating',
    READY: 'Ready',
    QUEUED: 'Queued',
    RUNNING: 'Restoring',
    COMPLETED: 'Completed',
    FAILED: 'Failed',
  },
} as const;

export const backupRestoreFr = {
  ...backupRestoreEn,
  title: 'Restauration',
  description: 'Validez l’archive, résolvez les conflits puis restaurez les données.',
  fromExisting: 'Valider une sauvegarde existante',
  noSource: 'Aucune sauvegarde terminée.',
  or: 'ou',
  upload: 'Téléverser une archive chiffrée',
  validating: 'Validation de l’archive',
  preview: 'Aperçu de restauration validé',
  execute: 'Créer la sauvegarde de sécurité et restaurer',
  queued: 'La restauration a été mise en file.',
  history: 'Historique des restaurations',
  report: 'Télécharger le rapport',
} as const;
export const backupRestoreEs = {
  ...backupRestoreEn,
  title: 'Restauración',
  description: 'Valida el archivo, resuelve conflictos y solo entonces restaura los datos.',
  fromExisting: 'Validar una copia existente',
  noSource: 'No hay copias finalizadas.',
  or: 'o',
  upload: 'Subir archivo cifrado',
  validating: 'Validando archivo',
  preview: 'Vista previa validada',
  execute: 'Crear copia de seguridad y restaurar',
  queued: 'La restauración se añadió a la cola.',
  history: 'Historial de restauración',
  report: 'Descargar informe',
} as const;
export const backupRestoreTr = {
  ...backupRestoreEn,
  title: 'Geri yükleme',
  description: 'Arşivi doğrulayın, çakışmaları çözün ve ardından verileri geri yükleyin.',
  fromExisting: 'Mevcut yedeği doğrula',
  noSource: 'Tamamlanmış yedek yok.',
  or: 'veya',
  upload: 'Şifreli arşiv yükle',
  validating: 'Arşiv doğrulanıyor',
  preview: 'Doğrulanmış geri yükleme önizlemesi',
  execute: 'Güvenlik yedeği oluştur ve geri yükle',
  queued: 'Geri yükleme kuyruğa alındı.',
  history: 'Geri yükleme geçmişi',
  report: 'Sonuç raporunu indir',
} as const;
